import React from "react";
import { makeStyles } from "@mui/styles";
import { List, ListItem, ListItemText, Typography } from "@mui/material";
import Helper from "../../common/Helper";
import CultureInfo from "../../common/CultureInfo";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    padding: theme.spacing(1),
    border: "solid 1px #ccc",
  },
  listItem: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  videoInfo: {
    alignSelf: "start",
  },
}));

export default function VideoList(props) {
  const classes = useStyles();
  return (
    <List>
      {props.auditVideoList.map((audit, index) => (
        <ListItem
          button
          sx={{
            backgroundColor:
              props.activeVideo.videoUrl === audit.videoUrl ? "#e6eeff" : "",
          }}
          key={index}
          className={classes.listItem}
          onClick={() => props.handleVideoSelect(audit)}
        >
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 800 }}
            className={classes.videoInfo}
          >
            {audit.playerName}
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 700 }}
            className={classes.videoInfo}
          >
            {audit.drillType}
          </Typography>
          <Typography variant="caption" className={classes.videoInfo}>
            {Helper.FormatDateTime(
              moment(audit.createdDate).format(),
              CultureInfo.GetCultureInfo().DateTimeFormat
            )}
          </Typography>
        </ListItem>
      ))}
    </List>
  );
}
